import {Paper, Radio, Stack, Text, Tooltip} from '@mantine/core';
import React from 'react';

interface SelectableRadioCardProps {
  cardClassName: string;
  description?: string;
  disabled: boolean;
  label: string;
  onSelect: () => void;
  showTooltip: boolean;
  tooltipLabel?: string;
  value: string;
  children?: React.ReactNode;
}

function handleCardKeyDown(
  event: React.KeyboardEvent<HTMLDivElement>,
  onActivate: () => void,
  disabled: boolean
): void {
  if (disabled) {
    return;
  }
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    onActivate();
  }
}

export default function SelectableRadioCard({
  cardClassName,
  description,
  disabled,
  label,
  onSelect,
  showTooltip,
  tooltipLabel,
  value,
  children,
}: SelectableRadioCardProps): JSX.Element {
  const card = (
    <Paper
      withBorder={true}
      p="sm"
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      onClick={() => {
        if (!disabled) {
          onSelect();
        }
      }}
      onKeyDown={(event) => {
        handleCardKeyDown(event, onSelect, disabled);
      }}
      className={cardClassName}
    >
      <Stack spacing="sm">
        <Radio value={value} label={label} disabled={disabled} />
        {description != null && (
          <Text size="xs" color="dimmed">
            {description}
          </Text>
        )}
        {children}
      </Stack>
    </Paper>
  );

  if (!showTooltip || tooltipLabel == null) {
    return card;
  }
  return <Tooltip label={tooltipLabel}>{card}</Tooltip>;
}
